import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import { ReduxFormNames } from 'swag-client-common/constants';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import UnderlinedInput from 'swag-client-common/components/inputs/underlined-input';
import { DropdownInput } from 'swag-client-common/components/inputs/dropdown-input';
import { UnderlinedPasswordInput } from 'swag-client-common/components/inputs/password-input';
import PasswordRequirementsBlock from 'swag-client-common/components/info/password-requirements-block';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import { TosCheckbox } from 'swag-client-common/components/partials/tos-checkbox';
import { required, password as passwordValidator } from 'swag-client-common/utils/redux-form-validators';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { Button } from '../../ui/button';
import { warn, validate } from './signup-form.validate';
import EmailField from './components/email-field';
import classes from './signup-popup.scss';
const TrapChild = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  let {
      isOpen,
      onClose,
      isLimitedEdition
    } = _ref,
    props = _objectWithoutProperties(_ref, ["isOpen", "onClose", "isLimitedEdition"]);
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    onRequestClose: onClose,
    content: /*#__PURE__*/React.createElement(SignUpFormContent, props),
    dataPopup: "SignUp",
    dialogClass: classes.popup,
    bodyClassName: classes.bodyClassName,
    contentClassName: classes.contentClassName,
    actionsContainerClassName: classes.actionsContainerClassName,
    paperClassName: classes.paperClassName,
    closeButtonClassName: isLimitedEdition ? classes.orangeClose : ''
  });
});
TrapChild.displayName = 'TrapChild';
const SignUpFormContent = props => {
  const {
    additionalMessage,
    handleSubmit,
    onShowLogIn,
    onSubmit,
    isLoading,
    isSubmitError,
    submitErrorMessage = '',
    departmentValues,
    showDepartmentField = false,
    isMailDomainPredefined,
    mailDomain,
    includeName = false,
    isBtnClickable = false,
    password,
    completedPasswordRequirements,
    isAllPasswordRequirementsCompleted,
    isPasswordLengthMoreThanMaxAllowedCharacters,
    isPasswordInputFocused,
    isLimitedEdition,
    valid
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, "Sign Up"), /*#__PURE__*/React.createElement("form", {
    className: classnames(classes.form, utilClasses.textCenter),
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.submitError, {
      [classes.showSubmitError]: isSubmitError
    })
  }, submitErrorMessage), additionalMessage && /*#__PURE__*/React.createElement("div", null, additionalMessage), includeName && /*#__PURE__*/React.createElement(_Field, {
    dataInput: "FirstName",
    name: "firstName",
    component: UnderlinedInput,
    type: "text",
    validate: [required],
    label: "First name",
    errorClassName: classes.errorClassName,
    className: classes.classNameInput,
    autoFocus: true
  }), includeName && /*#__PURE__*/React.createElement(_Field, {
    dataInput: "LastName",
    name: "lastName",
    component: UnderlinedInput,
    type: "text",
    validate: [required],
    label: "Last name",
    errorClassName: classes.errorClassName,
    className: classes.classNameInput
  }), /*#__PURE__*/React.createElement(EmailField, {
    isMailDomainPredefined: isMailDomainPredefined,
    mailDomain: mailDomain
  }), /*#__PURE__*/React.createElement(_Field, {
    dataInput: "Password",
    name: "password",
    component: UnderlinedPasswordInput,
    isLimitedEdition: isLimitedEdition,
    isAllPasswordRequirementsCompleted: isAllPasswordRequirementsCompleted,
    type: "password",
    validate: [required, passwordValidator],
    label: "Create password",
    errorClassName: password ? classes.strengthInputErrorClassName : classes.errorClassName,
    className: classes.classNameInput
  }), /*#__PURE__*/React.createElement(PasswordRequirementsBlock, {
    isLengthMoreThanMaxAllowedCharacters: isPasswordLengthMoreThanMaxAllowedCharacters,
    completedRequirements: completedPasswordRequirements,
    isAllRequirementsCompleted: isAllPasswordRequirementsCompleted,
    isInputFocused: isPasswordInputFocused
  }), showDepartmentField && departmentValues && /*#__PURE__*/React.createElement(_Field, {
    dataInput: "Department",
    name: "department",
    type: "text",
    component: DropdownInput,
    format: null,
    values: departmentValues,
    label: "Department",
    errorClassName: classes.errorClassName,
    className: classes.classNameInput
  }), /*#__PURE__*/React.createElement(TosCheckbox, {
    isFixedStyling: false,
    buttonName: "Sign Up",
    tosCheckboxWrapperClassName: classes.signUpWrapper
  }), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    size: "small",
    loading: isLoading,
    className: classnames(classes.submitButton, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    formType: "submit",
    disabled: !isBtnClickable || !valid,
    dataButton: "SignUp"
  }, "Sign Up")), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Already have an account?", ' ', /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.link, {
      [classes.orangeColor]: isLimitedEdition
    }),
    onClick: onShowLogIn,
    onKeyDown: e => handleOnEnterPressed(e, onShowLogIn),
    tabIndex: 0
  }, "Login")));
};
const SignupForm = _ref2 => {
  let {
      isOpen,
      onClose,
      isLimitedEdition,
      showCloseButton
    } = _ref2,
    props = _objectWithoutProperties(_ref2, ["isOpen", "onClose", "isLimitedEdition", "showCloseButton"]);
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    onRequestClose: onClose,
    content: /*#__PURE__*/React.createElement(SignUpFormContent, props),
    dataPopup: "SignUp",
    dialogClass: classes.popup,
    bodyClassName: classes.bodyClassName,
    contentClassName: classes.contentClassName,
    actionsContainerClassName: classes.actionsContainerClassName,
    paperClassName: classes.paperClassName,
    closeButtonClassName: isLimitedEdition ? classes.orangeClose : '',
    showCloseButton: showCloseButton
  });
};
export const SignupPopupComponent = _reduxForm({
  form: ReduxFormNames.SignUpForm,
  validate,
  warn
})(SignupForm);